import React, { useState } from "react";
import DefaultLayout from "layout/defaultLayout";
import PageTitles from "../../components/PageTitles";
import {Box, CircularProgress, Drawer} from "@mui/material";
import DisplayAdsCampaignCreatorComponent from "../../features/display-ads-campaign/DisplayAdsCampaignCreator";
import {useNavigate, useParams} from "react-router-dom";
import {createDisplayAdsCampaign} from "./utils/createCampaignDisplayAds";
import { useSnackbar } from "notistack";

const DisplayAdsCampaignCreator = () => {
    const navigate = useNavigate();
    const { idaccount, idhotel } = useParams();
    const [selectedLanguage, setSelectedLanguage] = useState("");
    const [campaignName, setCampaignName] = useState("");
    const [finalURL, setFinalURL] = useState('');
    const [landscape, setLandscape] = useState([]);
    const [logo, setLogo] = useState([]);
    const [errors, setErrors] = useState({});
    const {enqueueSnackbar} = useSnackbar()
    const [drawerOpen,setDrawerOpen] = useState(false)

    const createCampaignSettingsPayload = () => ({
        campaign_name: campaignName,
        campaign_lang: selectedLanguage,
    });

    const createAdsCreativePayload = () => ({
      final_url: {url: finalURL},
      marketing_image: landscape.map(l => ({assetContent: l})),
      logo_image: logo.map(l => ({assetContent: l}))
  });

    const handleCreateCampaign = async (campaignSettings, campaignAdsCreative) => {
      setDrawerOpen(true)
        const response = await createDisplayAdsCampaign({
            accountId: idaccount,
            hotelId: idhotel,
            campaignSettings,
            campaignAdsCreative,
        });

        if (response.success) {
          setDrawerOpen(false)
          enqueueSnackbar({
            message: "Display Ads campaign created successfully.",
            variant: "success"
          })
            setTimeout(() => {
              navigate(`/display-ads-campaign-manager/${idaccount}`);
            }, 2000);
        } else {
            setDrawerOpen(false)
            setErrors(response.errors || {});
            return;
        }
    };

    return (
      <DefaultLayout page="Display Ads">
        <PageTitles
          pageTitle="Display Ads"
          pageSubTitle="Campaign Creator"
          onClose={() => navigate(`/display-ads-campaign-manager/${idaccount}`)}
        />

        <Box p={2} className="display-ads-campaign-creator-container">
          <DisplayAdsCampaignCreatorComponent
            hotelId={idhotel}
            accountId={idaccount}
            campaignName={campaignName}
            setCampaignName={setCampaignName}
            selectedLanguage={selectedLanguage}
            setSelectedLanguage={setSelectedLanguage}
            finalURL={finalURL}
            setFinalURL={setFinalURL}
            setLandscape={setLandscape}
            landscape={landscape}
            logo={logo}
            setLogo={setLogo}
            onCreateCampaign={() => {
              handleCreateCampaign(
                createCampaignSettingsPayload(),
                createAdsCreativePayload()
              );
            }}
            onCancel={() => {
              navigate(`/display-ads-campaign-manager/${idaccount}`);
            }}
            errors={errors}
          />
          <Drawer
            anchor="top"
            open={drawerOpen}
            PaperProps={{
              sx: {
                background: "transparent",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
              }}
            >
              <CircularProgress size={60} color="primary" />
            </Box>
          </Drawer>
        </Box>
      </DefaultLayout>
    );
};

export default DisplayAdsCampaignCreator;
